module.exports = __webpack_public_path__ + "img/noicon.e5a5e6ae.png";